import { $appHook, genHookSet } from '@shared/model/$appHook'
import { $toast } from './$toast'

const hookPref = '$AxE2.'
const axe2Hooks = (actionName) => genHookSet(hookPref + actionName)
export const $AxE2AppHooks = {
  /**
   * window.$AxE2.$hooks.
   */
  signIn: axe2Hooks('signIn'),
  signInRequired: hookPref + 'signInRequired',
  signOut: axe2Hooks('signOut'),
  signUp: axe2Hooks('signUp'),
  passwordReset: axe2Hooks('passwordReset'),
  cart: {
    add: axe2Hooks('cart.add'),
    delete: {
      AFTER: hookPref + 'cart.delete.AFTER',
    },
    commitOrder: axe2Hooks('commitOrder'),
  },
  deliveryAddresses: {
    add: axe2Hooks('deliveryAddresses.add'),
    edit: axe2Hooks('deliveryAddresses.edit'),
    delete: axe2Hooks('deliveryAddresses.delete'),
  },
  creditCards: {
    add: axe2Hooks('creditCards.add'),
    delete: axe2Hooks('creditCards.delete'),
  },
  user: {
    leave: axe2Hooks('user.leave'),
    review: {
      edit: axe2Hooks('review.edit'),
      delete: axe2Hooks('review.delete'),
    },
  },
  notify: {
    arrival_items: {
      add: axe2Hooks('notify.arrival_items.add'),
      delete: axe2Hooks('notify.arrival_items.delete'),
      email: {
        BEFOR: hookPref + 'notify.arrival_items.email.befor',
        AFTER: hookPref + 'notify.arrival_items.email.after',
      },
    },
  },
  jsonItems: {
    loadItemJson: hookPref + 'jsonItems.loadItemJson',
    itemJsonLoaded: hookPref + 'jsonItems.itemJsonLoaded',
    initializeFiltersOnPageLoad: hookPref + 'jsonItems.initializeFiltersOnPageLoad',
    jsonItemListComponent: hookPref + 'jsonItems.jsonItemListComponent',
  },
  components: {
    UserCreditCards: hookPref + 'UserCreditCards.component',
    GMOPGCreditCardAddNew: {
      beforeForm: hookPref + 'GMOPGCreditCardAddNew.beforeForm.component',
      beforeSubmit: hookPref + 'GMOPGCreditCardAddNew.beforeSubmit.component',
      afterForm: hookPref + 'GMOPGCreditCardAddNew.afterForm.component',
    },
    CartPaymentInput: {
      before: hookPref + 'CartPaymentInput.beforeForm.component',
      beforeSubmit: hookPref + 'CartPaymentInput.beforeSubmit.component',
      after: hookPref + 'CartPaymentInput.afterForm.component',
    },
    UserOrderHistories: {
      item: {
        itemListAfter: hookPref + 'UserOrderHistories.item.itemListAfter.component',
        after: hookPref + 'UserOrderHistories.item.after.component',
      },
    },
  },
  asynMovePageBefore: hookPref + 'asynMovePageBefore',
  passwordResetAfter: hookPref + 'passwordResetAfter',
  contactSubmitAfter: hookPref + 'contactSubmitAfter',
  editInquiryMailBody: hookPref + 'editInquiryMailBody',
  signinLock: hookPref + 'signinLock',
  itemDetail: hookPref + 'itemDetail',
  itemList: hookPref + 'itemList',
}

/**
 * ログアウトHooks
 */
$appHook.registerHook($AxE2AppHooks.signOut.BEFORE, null, () => {
  if (window.confirm('ログアウトします。よろしいですか？') === false) {
    throw new Error('signOut cancelled')
  }
})
$appHook.registerHook($AxE2AppHooks.signOut.AFTER, null, () => {
  $toast.success('ログアウトしました。')
  // setTimeout(() => window.location.reload(), 800)
})

/**
 * カートへ追加Hook
 */
$appHook.registerHook($AxE2AppHooks.cart.add.AFTER, null, (currentValue, callerContext, args) => {
  $toast.success('カートへ追加しました。')
})
$appHook.registerHook($AxE2AppHooks.cart.add.ERROR, null, (currentValue, callerContext, args) => {
  $toast.error('カートへ追加できませんでした。')
})
